export default __webpack_public_path__ + "static/media/selenium-2.1d6497c0.svg";